/**
 * REVERSE-SUSPECT.UTILS
 * Question probably set the wrong way round ("reverse" option) according to the AI of the project assistant :
 * a negative statement (agreeing is a problem) not reversed, or a positive statement reversed
 */

//Under this confidence the assistant says nothing (measured on 455 standard questions : 0.7 % of false alerts at 0.85)
export const REVERSE_CONFIDENCE: number = 0.85

//What the server remembers in the options of a question (options.ai) after an analysis
export interface PolarityMemory {
  key?: string
  text: string //The analyzed text, normalized
  language?: string
  polarity: "positive" | "negative" | "neutral"
  confidence: number
}

export type ReverseSuspect = "should-reverse" | "should-not-reverse"

//Same normalization as the server : the answer concerns the text only if it is still the same
export function normalizeText(text: string): string {
  return text.trim().replace(/\s+/g, " ").toLowerCase()
}

//The memory of a question, only if it is valid (shape, same text as now)
export function getValidMemory(memory: any, currentText: string): PolarityMemory | null {
  if (!memory || typeof memory !== "object") return null
  if (typeof memory.text !== "string" || typeof memory.confidence !== "number") return null
  if (!["positive", "negative", "neutral"].includes(memory.polarity)) return null
  if (normalizeText(memory.text) !== normalizeText(currentText)) return null
  return memory as PolarityMemory
}

//What the AI says about the "reverse" option of a question, null when there is nothing to say
export function getReverseSuspect(reverse: boolean, memory: PolarityMemory | null): ReverseSuspect | null {
  if (!memory || memory.confidence < REVERSE_CONFIDENCE) return null
  if (memory.polarity === "negative" && !reverse) return "should-reverse"
  if (memory.polarity === "positive" && reverse) return "should-not-reverse"
  return null
}
